const _ = require('lodash');
const FILTER_TYPE = require('./advance-filter/filter-type-enum');

function FilterCtrl(filtersService) {
    this.filtersService = filtersService;
    this.filters = [];
    this.noOfFilterApplied = 0;
    this.filterType = {
        brand: FILTER_TYPE.BRAND,
        price: FILTER_TYPE.PRICE,
        range: FILTER_TYPE.RANGE,
        term: FILTER_TYPE.TERM
    };
}

FilterCtrl.prototype.initFilter = function (filters, callback) {
    if (filters.length !== 0) {
        this.filters = this.filtersService.initialise(FILTER_TYPE.FILTER_TYPE_DESKTOP);
        this.noOfFilterApplied = 0;
        _.each(this.filtersService.appliedFilter, (obj) => {
            this.noOfFilterApplied += obj.Items.length;
        });

        callback();
    }
};

FilterCtrl.prototype.applyQuickFilter = function (filter) {
    if (filter.Results.length === 0 && filter.Results[0].Count === 0) {
        filter.Results[0].Applied = false;
        return;
    }
    if (filter.FilterType === this.filterType.term) {
        this.filtersService.applyFilter(filter.Name, {
            Term: filter.Results[0].Name
        });
    } else {
        this.filtersService.applyFilter(filter.Name, {
            Min: filter.Results[0].Min.toString(),
            Max: filter.Results[0].Max.toString()
        });
    }
};

module.exports = function (atm, filtersService) {
    return {
        restrict: 'E',
        scope: {
            sortSettingGroup: '@'
        },
        controllerAs: 'ctrl',
        controller: ['FiltersService', FilterCtrl],
        link(scope) {

            //TODO: Once Elastic search is integrated make this value dynamic
            scope.isAdvancedFilterOpen = false;
            scope.filtersService = filtersService;

            scope.toggleAdvancedFilters = function () {
                scope.isAdvancedFilterOpen = !scope.isAdvancedFilterOpen;
                if (scope.isAdvancedFilterOpen) {
                    scope.switchFilterTab(scope.ctrl.filters.advanceFilters[0]);
                }
            };

            scope.switchFilterTab = function (selectedFilter) {
                scope.selectedFilter = selectedFilter;
                scope.advancedFilter = scope.selectedFilter.Name;
            };

            scope.$watch('filtersService.filters', (filters) => {
                if (filters && filters.length !== 0) {
                    scope.ctrl.initFilter(filters, () => {
                        if (scope.selectedFilter) {
                            const filterIndex = _.findIndex(filters, {
                                Name: scope.selectedFilter.Name
                            });
                            scope.selectedFilter = filters[filterIndex];
                        } else {
                            scope.switchFilterTab(scope.ctrl.filters.advanceFilters[0]); //To reset filter tab on refresh
                        }

                        const allSelectedFilters = [];

                        if (scope && scope.ctrl && scope.ctrl.filters && scope.ctrl.filters.quickFilters) {
                            scope.ctrl.filters.quickFilters.forEach(quickFilter => {
                                const allSelectedItems = [];

                                quickFilter.Results.forEach(element => {
                                    if (element.Applied) {
                                        allSelectedItems.push(element.Name);
                                    }
                                });

                                if (allSelectedItems.length !== 0) {
                                    allSelectedFilters.push({
                                        filterCategory: quickFilter.Name,
                                        filterSelected: allSelectedItems.join(','),
                                        filterLocation: 'quick filter'
                                    });
                                }
                            });
                        }

                        scope.ctrl.filters.advanceFilters.forEach(advanceFilter => {
                            const allSelectedItems = [];

                            advanceFilter.Results.forEach(element => {
                                if (element.Applied) {
                                    allSelectedItems.push(element.Name);
                                }
                            });

                            if (allSelectedItems.length !== 0) {
                                allSelectedFilters.push({
                                    filterCategory: advanceFilter.Name,
                                    filterSelected: allSelectedItems.join(','),
                                    filterLocation: 'advanced filter'
                                });
                            }
                        });

                        const atmData = {
                            area: 'filter result',
                            keyword: this.searchTerm,
                            searchCount: '',
                            store: {},
                            category: {},
                            product: {},
                            searchCategory: '',
                            filters: allSelectedFilters
                        };

                        if (allSelectedFilters.length !== 0) {
                            atm.pushWithSearchMapper(atmData);
                        }
                    });
                }
            });
            filtersService.resetFilter();
        },
        template: require('./filters-template.html').trim()
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/filters/filters-directive.js
 **/